/*export const WEATHER_ICONS_MAP = {
  TEMPESTA: './assets/components/weather/4102318_thunderbolt_storm_heavy rain_thunderstorm_weather_rain_cloud.png',
  PIOGGIA_NUVOLE: './assets/components/weather/4102327_rain_cloud_drizzle_weather.png',
  PIOGGIA: './assets/components/weather/4102317_rain_cloud_weather.png',
  NUVOLOSO_CON_POSSIBILI_PIOGGIE: './assets/components/weather/4102327_rain_cloud_drizzle_weather.png',
  NUVOLOSO: './assets/components/weather/4102315_weather_cloud.png',
  NUVOLOSO_SOLE: './assets/components/weather/4102326_cloud_weather_sun_sunny.png',
  NUVOLOSO_LUNA: './assets/components/weather/4102321_moon_crescent_half_weather_half moon_night.png',
  SOLE_SERENO: './assets/components/weather/4102328_weather_hot_sun.png',
  LUNA_SERNEO: './assets/components/weather/moon.png',
}*/

export const WEATHER_ICONS_MAP = {
  TEMPESTA: 'thunderstorm',
  PIOGGIA_NUVOLE: 'rainy',
  PIOGGIA: 'rainy',
  NUVOLOSO_CON_POSSIBILI_PIOGGIE: 'rainy',
  NUVOLOSO: 'cloudy',
  NUVOLOSO_SOLE: 'partly_cloudy_day',
  NUVOLOSO_LUNA: 'partly_cloudy_night',
  SOLE_SERENO: 'sunny',
  LUNA_SERNEO: 'bedtime'
}
